/* Built In Imports */
import { useState } from 'react';

/* External Imports */
import { Box, Button, Radio, RadioGroup, Text } from '@chakra-ui/react';
import { render } from 'datocms-structured-text-to-html-string';

/* Internal Imports */
/* Components */
import StructuredTextParser from '@components/Utility/ArticleParser/StructuredTextParser';
import { refineUrlDomain } from '@components/Utility/utils';
import config from '@config';
import NoSeatingAvailable from '@landing_pages/eoe/components/NoSeatingAvailable';
import { useEOEContext } from '@store/EOEContext';

/* Service */
import { searchByFieldId } from '@components/Utility/Shared/SharedService';

/**
 *
 * @param {Object} sectionContent
 * @returns
 */
const EnlightenmentSixRow = ({
  sectionContent,
  region,
  lang,
  pageData,
  listTicket,
  setListTicket,
  isCityClicked,
  selTab,
}) => {
  let appendUrlParameter = '';
  if (lang === 'hi') {
    appendUrlParameter = "&lang=hi_IN";
  } else {
    appendUrlParameter = '';
  }
  const { city, isIeDone, isIeMode, ieLang, cityName } = useEOEContext();
  const [tokenId, setTokenId] = useState('');

  const listEventTicketRow = index => {
    const ticket = listTicket?.tickets?.[index];
    if (!ticket) return null;

    const { name, json_pricing } = ticket;
    let price = json_pricing?.base?.original_price;
    let discountedPrice = json_pricing?.base?.price;

    if (!isIeDone) {
      price =
        json_pricing?.base?.original_price +
        (ieLang === 'en'
          ? json_pricing?.english_price?.original_price
          : json_pricing?.vernacular_price?.original_price);
      discountedPrice =
        json_pricing?.base?.price +
        (ieLang === 'en'
          ? json_pricing?.english_price?.price
          : json_pricing?.vernacular_price?.price);
    }

    const getColorForIndex = index => {
      switch (index) {
        case 1:
          return '#185171';
        case 2:
          return '#562D2F';
        case 3:
          return '#0E3F3C';
        case 4:
          return '#0E3F4F';
        default:
          return 'inherit';
      }
    };

    let InrRupees = new Intl.NumberFormat('en-IN', {
      style: 'currency',
      currency: 'INR',
    });

    return (
      <Box
        height={{ base: '52px', md: '80px' }}
        w={{
          base: index == 0 ? '176px' : '180px',
          md: '266px',
        }}
        mx="auto"
        boxSizing="content-box"
        display="flex"
        alignItems="center"
        justifyContent="space-between"
      >
        {ticket?.json_pricing?.limited_seats_flag && searchByFieldId(sectionContent, 'limited_seats_flag') && (
          <Box
            bgColor="#D70000"
            color="#fff"
            fontSize={{ base: '8px', md: '10px' }}
            position="absolute"
            py={{ base: 1, md: 2 }}
            px={{ base: 2, md: 3 }}
            width={{ base: '66px', md: 'auto' }}
            fontFamily="'FedraSansStd-book'"
            zIndex="2"
            left="-6px"
            top="10px"
            _before={{
              width: 0,
              height: 0,
              content: "''",
              borderRight: '6px solid #870000',
              borderBottom: '6px solid transparent',
              borderTop: '0px solid #870000',
              position: 'absolute',
              left: 0,
              bottom: '-6px',
            }}
          >
            {/* Limited Seats Available */}
            {searchByFieldId(sectionContent, 'limited_seats_flag')?.text}
          </Box>
        )}

        <Box
          key={index}
          display="flex"
          alignItems="center"
          justifyContent={ticket?.seats_available ? 'space-between' : 'center'}
          w="full"
          px={{ base: '8px', md: '15px' }}
        >
          {ticket?.seats_available > 0 && (
            <>
              {name && (
                <RadioGroup
                  onChange={setTokenId}
                  value={tokenId}
                  size="md"
                  name={name}
                >
                  <Radio
                    value={ticket?.token}
                    // key={nanoid(2)}
                    isInvalid
                    bg="white"
                    border="1px solid"
                    _checked={{
                      background: '#CF4520',
                      border: '2px solid #fff',
                      outline: '4px solid #fff',
                      outlineOffset: '-5px',
                    }}
                  >
                    <Box
                      fontFamily="'FedraSansStd-medium'"
                      fontSize={{ base: '12px', md: '14px' }}
                    >
                      {name}
                    </Box>
                  </Radio>
                </RadioGroup>
              )}

              <Box
                display="flex"
                flexDir="column"
                fontSize={{ base: '10px', md: '12px' }}
                fontFamily="FedraSansStd-medium"
              >
                {price > 0 && (
                  <>
                    <Text textAlign="right">
                      {InrRupees.format(discountedPrice)
                        .replace('₹', 'INR ')
                        .replace('.00', '')}
                    </Text>
                    {discountedPrice != price && (
                      <Text
                        as="del"
                        fontFamily="FedraSansStd-medium"
                        color={getColorForIndex(index)}
                        textAlign="right"
                      >
                        {InrRupees.format(price)
                          .replace('₹', 'INR ')
                          .replace('.00', '')}
                      </Text>
                    )}
                  </>
                )}
              </Box>
            </>
          )}
          {name && !ticket?.seats_available ? (
            <NoSeatingAvailable
              name={name}
              price={price}
              discountedPrice={discountedPrice}
            />
          ) : (
            <></>
          )}
        </Box>
      </Box>
    );
  };

  const gtmClick = () => {
    // debugger;
    if (typeof window !== 'undefined') {
      window.dataLayer = window.dataLayer || [];

      window.dataLayer.push({
        event: 'EoE_Register_Now',
        IE_status: isIeDone ? 'Yes' : 'No',
        IE_Lang: ieLang,
        city: cityName,
      });

      window.dataLayer.push({ ecommerce: null });
      window.dataLayer.push({
        event: 'add_to_cart',
        ecommerce: {
          currency: '',
          value: '',
          items: [
            {
              item_id: city, // id of the program
              item_name:
                cityName?.toLowerCase() === 'chennai'
                  ? 'Sadhguruvudan Gyanam Dhyanam Anandham'
                  : 'Ecstasy of Enlightenment', // Name of the program (Ex - EoE)
              affiliation: '',
              coupon: '',
              discount: '',
              index: '',
              item_brand: isIeDone ? 'Yes' : 'No', //IE Status <Yes/No>
              item_category: ieLang, //IE Lang (User selected IE Language Ex- MR,EN,HI)
              item_category2: '',
              item_category3: '',
              item_category4: '',
              item_category5: '',
              item_list_id: '',
              item_list_name: '',
              item_variant: '',
              location_id: cityName,
              price: '',
              quantity: '',
            },
          ],
        },
      });
    }
  };

  if (isCityClicked && !city) {
    return <></>;
  }

  return (
    <Box
      display="flex"
      flexDir="column"
      alignItems="center"
      bg="#fff"
      opacity={city ?? 0.2}
      pointerEvents={city ?? 'none'}
    >
      {searchByFieldId(sectionContent, 'yes-dias') && (
        <Box
          bg="#DEB58E"
          px="50px"
          py="12px"
          fontSize="20px"
          borderRadius="9px"
          fontFamily="FedraSansStd-medium"
        >
          {searchByFieldId(sectionContent, 'yes-dias').text}
        </Box>
      )}
      {searchByFieldId(sectionContent, 'yes-sel-cat') && (
        <Box
          fontSize="16px"
          fontStyle="italic"
          fontFamily="FedraSansStd-medium"
          py="20px"
          textAlign={{ base: 'center', md: 'left' }}
        >
          {searchByFieldId(sectionContent, 'yes-sel-cat').text}
        </Box>
      )}
      <Box
        w={{ base: '300px', sm: '396px', md: '526px' }}
        display="flex"
        justifyContent="center"
        flexDir="column"
        alignItems="center"
        className="boxSixLayout"
      >
        <Box
          bg={
            !listTicket?.tickets[0]?.seats_available
              ? '#C6C6C6'
              : tokenId == listTicket?.tickets[0].token
              ? '#2c2459'
              : '#807c9c'
          }
          color={
            !listTicket?.tickets[0]?.seats_available
              ? '#6A6A6A'
              : tokenId == listTicket?.tickets[0].token && '#fff'
          }
          borderBottom={{ base: '6px solid #fff', md: '10px solid #fff' }}
          borderTop="0px"
          w={{ base: '180px', md: '266px' }}
          mx="auto"
          boxSizing="border-box"
          borderRadius="12px 12px 0 0"
          display="flex"
          alignItems="center"
          justifyContent="space-between"
          className="box1"
          as="label"
          cursor={
            !listTicket?.tickets[0]?.seats_available ? 'default' : 'pointer'
          }
        >
          {listEventTicketRow(0)}
        </Box>
        <Box
          bg={
            !listTicket?.tickets[1]?.seats_available
              ? '#C6C6C6'
              : tokenId == listTicket?.tickets[1].token
              ? '#176F9F'
              : '#74a9c5'
          }
          color={
            !listTicket?.tickets[1]?.seats_available
              ? '#6A6A6A'
              : tokenId == listTicket?.tickets[1].token && '#fff'
          }
          border={{ base: '6px solid #fff', md: '10px solid #fff' }}
          boxSizing="border-box"
          height="auto"
          w={{ base: '90%', sm: '76%', md: '396px' }}
          mx="auto"
          className="box2"
          as="label"
          cursor={
            !listTicket?.tickets[1]?.seats_available ? 'default' : 'pointer'
          }
        >
          {listEventTicketRow(1)}
        </Box>
        <Box
          bg={
            !listTicket?.tickets[2]?.seats_available
              ? '#C6C6C6'
              : tokenId == listTicket?.tickets[2].token
              ? '#693033'
              : '#a58385'
          }
          color={
            !listTicket?.tickets[2]?.seats_available
              ? '#6A6A6A'
              : tokenId == listTicket?.tickets[2].token && '#fff'
          }
          as="label"
          cursor={
            !listTicket?.tickets[2]?.seats_available ? 'default' : 'pointer'
          }
          display="flex"
          justifyContent="center"
          alignContent="center"
          border={{ base: '6px solid #fff', md: '10px solid #fff' }}
          boxSizing="border-box"
          height="auto"
          w={{ base: '85%', sm: '76%', md: '409px' }}
          className="box3"
        >
          {listEventTicketRow(2)}
        </Box>
        <Box
          as="label"
          cursor={
            !listTicket?.tickets[3]?.seats_available ? 'default' : 'pointer'
          }
          display="flex"
          justifyContent="center"
          alignContent="center"
          bg={
            !listTicket?.tickets[3]?.seats_available
              ? '#C6C6C6'
              : tokenId == listTicket?.tickets[3].token
              ? '#44827e'
              : '#8eb4b2'
          }
          color={
            !listTicket?.tickets[3]?.seats_available
              ? '#6A6A6A'
              : tokenId == listTicket?.tickets[3].token && '#fff'
          }
          w={{ base: '100%', md: '526px' }}
          borderBottom={{ base: '6px solid #fff', md: '10px solid #fff' }}
          borderRadius="12px 12px 0px  0px"
          className="box4"
        >
          {listEventTicketRow(3)}
        </Box>
        <Box
          bg={
            !listTicket?.tickets[4]?.seats_available
              ? '#C6C6C6'
              : tokenId == listTicket?.tickets[4].token
              ? '#376f81'
              : '#739aa7'
          }
          color={
            !listTicket?.tickets[4]?.seats_available
              ? '#6A6A6A'
              : tokenId == listTicket?.tickets[4].token && '#fff'
          }
          height={{ base: '52px', md: '80px' }}
          borderBottom={{ base: '6px solid #fff', md: '10px solid #fff' }}
          boxSizing="content-box"
          w={{ base: '100%', md: '526px' }}
          className="box5"
          position="relative"
          as="label"
          cursor={
            !listTicket?.tickets[4]?.seats_available ? 'default' : 'pointer'
          }
        >
          {listEventTicketRow(4)}
        </Box>
        <Box
          bg={
            listTicket?.tickets[5]?.seats_available < 1
              ? '#C6C6C6'
              : tokenId == listTicket?.tickets[5].token
              ? '#a68341'
              : '#c1a87a'
          }
          color={
            !listTicket?.tickets[5]?.seats_available
              ? '#6A6A6A'
              : tokenId == listTicket?.tickets[5].token && '#fff'
          }
          height={{ base: '52px', md: '80px' }}
          borderRadius="0 0 12px 12px "
          boxSizing="border-box"
          w={{ base: '100%', md: '526px' }}
          className="box6"
          as="label"
          cursor={
            !listTicket?.tickets[5]?.seats_available ? 'default' : 'pointer'
          }
        >
          {listEventTicketRow(5)}
        </Box>
      </Box>

      <Box py="10px">
        {sectionContent[28]?.buttonText && (
          <Button
            disabled={!tokenId}
            fontFamily="FedraSansStd-medium"
            fontWeight="400"
            color="#faf7f0"
            fontSize={{ base: '14px', md: '18px' }}
            opacity={tokenId ? '1' : '0.4'}
            cursor={tokenId ? 'pointer' : 'not-allowed'}
            background={tokenId ? '#CF4520' : '#333333'}
            _hover={{
              background: tokenId ? '#000054' : '#333333',
            }}
            onClick={() => {
              if (tokenId) {
                gtmClick();
                window.open(
                  refineUrlDomain(
                    `${config.EOE_EVENT_DOMAIN}/event/${city}/register?iso_ie_done=${isIeDone}&iso_ie_mode=${isIeMode}&iso_ie_lang=${ieLang}&iso_ticket_id=${tokenId}&iso_country_code=${pageData?.country}${appendUrlParameter}`
                  ),
                  '_blank'
                );
              }
            }}
          >
            {sectionContent[28].buttonText}
          </Button>
        )}
      </Box>

      {!selTab && (
        <Box maxW="498px">
          {searchByFieldId(sectionContent, 'no-text-1') && (
            <StructuredTextParser
              str={render(searchByFieldId(sectionContent, 'no-text-1').body)}
              region={region}
              lang={lang}
              fontFamily="FedraSansStd-book"
              fontStyle="italic"
              pb="20px"
              px="15px"
              mt="0"
            />
          )}
          {isIeDone && searchByFieldId(sectionContent, 'yes-price-include') && (
            <Box
              fontSize="16px"
              fontStyle="italic"
              fontFamily="FedraSansStd-book"
              py="5px"
              color="#303030"
              px="15px"
            >
              {searchByFieldId(sectionContent, 'yes-price-include').text}
            </Box>
          )}
          {!isIeDone && searchByFieldId(sectionContent, 'no-price-include') && (
            <Box
              fontSize="16px"
              fontStyle="italic"
              fontFamily="FedraSansStd-book"
              py="5px"
              color="#303030"
              px="15px"
            >
              {searchByFieldId(sectionContent, 'no-price-include').text}
            </Box>
          )}
        </Box>
      )}

      <style jsx global>
        {`
          .boxSixLayout {
            position: relative;
            padding-top: 40px;
          }
          .box1 {
            position: relative;
            z-index: 9;
            top: -40px;
          }
          .box1:hover {
            background: ${listTicket?.tickets?.[0]?.seats_available
              ? '#2c2459'
              : '#C6C6C6'};
            color: ${listTicket?.tickets?.[0]?.seats_available
              ? '#fff'
              : '#6A6A6A'};
          }
          .box2 {
            position: absolute;
            transform: translate(0%, 0%);
            top: 80px;
            z-index: 2;
            width: 286px;
          }
          .box2:hover {
            background: ${listTicket?.tickets?.[1]?.seats_available
              ? '#176f9f'
              : '#C6C6C6'};
            color: ${listTicket?.tickets?.[1]?.seats_available
              ? '#fff'
              : '#6A6A6A'};
          }
          .box2:hover del {
            color: #043753;
          }

          .box3 {
            position: absolute;
            transform: translate(0%, 0%);
            top: 120px;
            padding-top: 50px;
          }
          .box3:hover {
            background: ${listTicket?.tickets?.[2]?.seats_available
              ? '#693033'
              : '#C6C6C6'};
            color: ${listTicket?.tickets?.[2]?.seats_available
              ? '#fff'
              : '#6A6A6A'};
          }
          .box3:hover del {
            color: #290204;
          }
          .box4 {
            padding-top: 140px;
          }
          .box4:hover {
            background: ${listTicket?.tickets?.[3]?.seats_available
              ? '#44827e'
              : '#C6C6C6'};
            color: ${listTicket?.tickets?.[3]?.seats_available
              ? '#fff'
              : '#6A6A6A'};
          }
          .box4:hover del {
            color: #0e3f3c;
          }
          .box5:hover {
            background: ${listTicket?.tickets?.[4]?.seats_available
              ? '#376f81'
              : '#C6C6C6'};
            color: ${listTicket?.tickets?.[4]?.seats_available
              ? '#fff'
              : '#6A6A6A'};
          }
          .box5:hover del {
            color: #0e3f4f;
          }
          .box6:hover {
            background: ${listTicket?.tickets?.[5]?.seats_available
              ? '#a68341'
              : '#C6C6C6'};
            color: ${listTicket?.tickets?.[5]?.seats_available
              ? '#fff'
              : '#6A6A6A'};
          }
          .box6:hover del {
            color: #5e4310;
          }
          @media (max-width: 767px) {
            .box1 {
              top: -20px;
            }
            .box2 {
              width: 194px;
              top: 72px;
            }
            .box3 {
              top: 92px;
              padding-top: 39px;
            }
            .box4 {
              padding-top: 98px;
            }
          }
        `}
      </style>
    </Box>
  );
};

export default EnlightenmentSixRow;
